import React, { Component } from "react";
import { Link } from "react-router-dom";
class News_Content extends Component {
  render() {
    const { news, next, prev, url } = this.props;

    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <article className="hentry data-effect">
            <div
              className="post-media data-effect-item has-effect-icon offset-v-25 offset-h-24 clerafix"
              style={{
                height: "350px",
                background: `url(${news.srcimg})`,
                backgroundSize: "cover",
                backgroundPosition: "center center",
              }}
            >
              <div className="post-calendar">
                <span className="inner">
                  <span className="entry-calendar">
                    <span className="day">{news.day}</span>
                    <span className="month">{news.month}</span>
                  </span>
                </span>
              </div>
            </div>
            <div className="post-content-wrap clearfix">
              <h2 className="post-title">
                <span className="post-title-inner">
                  <Link
                    to={`/news?ID=${news.ID}&name=${news.title.replaceAll(
                      " ",
                      "-"
                    )}`}
                  >
                    {news.title}
                  </Link>
                </span>
              </h2>
              <div className="post-meta">
                <div className="post-meta-content">
                  <div className="post-meta-content-inner">
                    <span className="post-date item">
                      <span className="inner">
                        <span className="entry-date">{news.date}</span>
                      </span>
                    </span>
                    <span className="post-by-author item">
                      <span className="inner">
                        <Link to="#">By: {news.author}</Link>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              {news.URL ? (
                <div className="post-tags-socials clearfix">
                  <div className="">
                    <span>Link: </span>
                    <a target="_blank" href={news.URL} className="">
                      {news.URLtitle}
                    </a>
                  </div>
                  <br />
                </div>
              ) : null}
              <div className="post-content post-excerpt margin-bottom-43">
                <div dangerouslySetInnerHTML={{ __html: news.content }} />
              </div>
              <div className="post-tags-socials clearfix">
                <div className="post-tags ">
                  <span>Kategorije :</span>
                  {news.categories.map((cat) => (
                    <Link to="#">{cat}</Link>
                  ))}
                </div>
                <div className="post-socials ">
                  <a
                    target="_blank"
                    href={`https://www.facebook.com/sharer.php?u=${url}`}
                    className="facebook"
                  >
                    <span className="fa fa-facebook-square" />
                  </a>{" "}
                  <a
                    target="_blank"
                    href={`https://twitter.com/share?url=${url}&text=${news.title}&via=CityX&hashtags=CityX`}
                    className="twitter"
                  >
                    <span className="fa fa-twitter" />
                  </a>{" "}
                  <a
                    target="_blank"
                    href={`https://www.linkedin.com/shareArticle?url=${url}&title=${news.title}`}
                    className="linkedin"
                  >
                    <span className="fa fa-linkedin-square" />
                  </a>
                </div>
              </div>
            </div>
          </article>
          <div className="themesflat-pagination clearfix no-border padding-top-17">
            <ul className="page-prev-next">
              <li>
                <a
                  href={
                    prev
                      ? `/news?ID=${prev.ID}&name=${prev.title.replaceAll(
                          " ",
                          "-"
                        )}`
                      : "#"
                  }
                  className="prev"
                >
                  Previous Article
                </a>
              </li>
              <li className="text-right">
                <a
                  href={
                    next
                      ? `/news?ID=${next.ID}&name=${next.title.replaceAll(
                          " ",
                          "-"
                        )}`
                      : "#"
                  }
                  className="next"
                >
                  Next Article
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={80}
          data-mobile={60}
          data-smobile={60}
        />
      </div>
    );
  }
}

export default News_Content;
